import appConstants from "../../../../../appConstants";
import { StaticFilter, MultiSelectFilter } from '@dataGrid/components/columnFilters';
import { CommandCellRenderer } from '@dataGrid/components/cellRenderer';

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration({ terminalAccessLabel }) {
    return GridConfig.getDefaultConfiguration({ terminalAccessLabel });
  }

  static getCommandCellRenderer = (params) => {
    const commandConfig = {
      editCommand: "editAccessibleTerminal",
      editTitle: "Update Accessible Terminal",
      deleteCommand: "deleteAccessibleTerminal",
      deleteTitle: "Delete Accessible Terminal",
    };
    return <CommandCellRenderer commandConfig={commandConfig} params={{ ...params }} />;
  };

  static getStaticOptions = (params) => {
    const allRows = [];
    params.api.forEachNode((node) => {
      allRows.push(...(node.data?.accessibleTerminals || []));
    });
    const uniqueAccessibleTerminals = [...new Set(allRows)];
    return uniqueAccessibleTerminals.map((accessibleTerminal) => ({
      value: accessibleTerminal,
      text: accessibleTerminal,
    }));
  };
  

  static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.FeederTerminal,
      keyColumn: "terminalCode",
      rowSelection: "single",
      defaultColDef: {
        filter: MultiSelectFilter,
      },
      columns: [
        {
          headerName: "Terminal",
          field: "terminalCode",
          headerTooltip: "Terminal",
          minWidth: appConstants.columnWidth.TERMINAL,
          maxWidth: appConstants.columnWidth.TERMINAL,
        },
        {
          headerName: "Accessible Terminal",
          headerTooltip: "Accessible Terminal",
          minWidth: appConstants.columnWidth.ACCESSIBLE_TERMINAL,
          valueGetter: (params) => {
            return params.data.accessibleTerminals || [];
          },
          filter: StaticFilter,
          filterParams: {
            getStaticOptions: GridConfig.getStaticOptions,
          },
          tooltipValueGetter: (params) => params.value,
        },
        {
          headerName: "Action",
          headerTooltip: "Action",
          field: "action",
          cellRenderer: GridConfig.getCommandCellRenderer,
          minWidth: appConstants.columnWidth.ACTION,
          maxWidth: appConstants.columnWidth.ACTION,
          filter: null,
        },
      ],
    };
  }
}
